import { useCuttingStore } from './state/useCuttingStore';
import { isCompletePart } from './model/partsUtils';
import { EdgeMiniSvg, GrooveMiniSvg } from './components/EdgeGrooveMiniSvg';
import type { Part } from './model/types';

/**
 * Block 14 «Раскрой» — список деталей для ПЕЧАТИ (PR #25 #168, refine #168-A).
 *
 * Print-only (`.cut-print-only`: `display:none` на экране, `@media print` → показ).
 * Рендерится внутри `.cutting-print-region` (CuttingProject) — на печати уходит на
 * страницу 2 (метрики + детали), карта раскроя — на страницу 1 (landscape, page-break).
 * Колонки: №, Наименование, Длина, Ширина (раздельно, #168-A #2), Кол-во, Кромки/Пазы
 * (мини-SVG схемой — тот же `EdgeMiniSvg`/`GrooveMiniSvg`, что в таблице «Детали и
 * кромки», #168-A #1), Обработка. Данные — `document.parts` (только заполненные,
 * `isCompletePart`). Read-only, без интерактива.
 */
export function CutPrintDetails() {
  const parts = useCuttingStore((s) => s.document.parts);

  const rows: Part[] = parts.filter(isCompletePart);
  if (rows.length === 0) return null;

  return (
    <div className="cut-print-only cut-print-details">
      <div className="cut-print-details-title">Список деталей</div>
      <table className="cut-print-details-table">
        <thead>
          <tr>
            <th>№</th>
            <th>Наименование</th>
            <th>Длина</th>
            <th>Ширина</th>
            <th>Кол-во</th>
            <th>Кромки</th>
            <th>Пазы</th>
            <th>Обработка</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((p, i) => (
            <tr key={p.id}>
              <td>{i + 1}</td>
              <td>{p.name || '—'}</td>
              <td>{p.length}</td>
              <td>{p.width}</td>
              <td>{p.qty}</td>
              <td>
                <EdgeMiniSvg edges={p.edges} />
              </td>
              <td>
                <GrooveMiniSvg grooves={p.grooves} />
              </td>
              <td>{p.processing || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
